import { PickupOrderPickedUpDialog } from '@/dialogs/pickup-order-picked-up.dialog'
import { PickupOrderReadyDialog } from '@/dialogs/pickup-order-ready.dialog'
import { usePickupOrderReminders } from '@/hooks/use-pickup-order-reminders'
import { PickupOrderAlertStageEnum } from '@/types/order-alerts.types'

function PickupOrderReminders() {
  const {
    activePopup,
    isUpdating,
    dismissActivePopup,
    markOrderReady,
    markOrderPickedUp,
  } = usePickupOrderReminders()

  return (
    <>
      <PickupOrderReadyDialog
        open={activePopup?.stage === PickupOrderAlertStageEnum.CONFIRM_READY}
        orderNumber={activePopup?.shortId ?? ''}
        customerName={activePopup?.customerName ?? ''}
        isLoading={isUpdating}
        onNotReady={() => {
          void dismissActivePopup()
        }}
        onReady={() => {
          void markOrderReady()
        }}
      />
      <PickupOrderPickedUpDialog
        open={
          activePopup?.stage === PickupOrderAlertStageEnum.CONFIRM_PICKED_UP
        }
        orderNumber={activePopup?.shortId ?? ''}
        customerName={activePopup?.customerName ?? ''}
        isLoading={isUpdating}
        onNo={() => {
          void dismissActivePopup()
        }}
        onPickedUp={() => {
          void markOrderPickedUp()
        }}
      />
    </>
  )
}

export { PickupOrderReminders }
